module.exports = __webpack_public_path__ + "static/media/SF-5-A (1).8a4e0bfa.mp3";